import { Select } from 'antd';
import { SPEAKER_ROLES, type SpeakerRole } from '../lib/api';

const LABEL: Record<SpeakerRole, string> = {
  speaker: 'Speaker',
  host: 'Host',
  panellist: 'Panellist',
  moderator: 'Moderator',
};

export function RoleSelector({
  value,
  onChange,
  size = 'small',
}: {
  value: SpeakerRole;
  onChange: (role: SpeakerRole) => void;
  size?: 'small' | 'middle';
}) {
  return (
    <Select
      size={size}
      value={value}
      onChange={onChange}
      bordered={false}
      style={{ minWidth: 110, color: '#999', fontWeight: 600 }}
      options={SPEAKER_ROLES.map((r) => ({ value: r, label: LABEL[r] }))}
    />
  );
}
